import {
  EDIT_RECEIVER_GENDER_NAME,
  EDIT_RECEIVER_GENERAL_DETAILS_PHONE_NUMBER_FIELDS,
  EDIT_RECEIVER_MOBILE_NAME,
  EDIT_RECEIVER_PERSONAL_DETAILS_GENDER_FIELD,
  EDIT_RECEIVER_PERSONAL_DETAILS_SELECT_TYPE_OF_RECEIVER_FIELD,
  EDIT_RECEIVER_PHONE_NAME,
  EDIT_RECEIVER_RELATIONSHIP_FIELD,
  EDIT_RECEIVER_RELATIONSHIP_NAME,
  EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME,
} from 'constants';
import useFormAddReceiverStore from 'hooks/form-add-receiver/useFormAddReceiverStore';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';

const withUpdateReceiverPersonalDetailsValidationInitial = (Component) => {
  const UpdateReceiverPersonalDetailsValidationInitialComponent = (props) => {
    const {
      information,
      validation,
      setValidation,
      mobileConfig,
      phoneConfig,
      relationshipConfig,
      eitherRequiredMsg,
      setEitherRequiredMsg,
    } = props || {};

    const { currentReceiver } = useFormAddReceiverStore();

    const { mobileNumber, phoneNumber } = currentReceiver || {};

    const currentReceiverType =
      information[EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME];
    const currentReceiverGender = information[EDIT_RECEIVER_GENDER_NAME];
    const currentReceiverMobile = information[EDIT_RECEIVER_MOBILE_NAME];
    const currentReceiverPhone = information[EDIT_RECEIVER_PHONE_NAME];
    const currentReceiverRelationship =
      information[EDIT_RECEIVER_RELATIONSHIP_NAME];

    const computeValidation = () => {
      if (isEmpty(currentReceiver)) return validation;

      let next = {};

      console.log('currentReceiverType', currentReceiverType);
      if (!currentReceiverType) {
        next[EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME] =
          EDIT_RECEIVER_PERSONAL_DETAILS_SELECT_TYPE_OF_RECEIVER_FIELD.msgRequired;
        return next;
      }

      if (!currentReceiverGender) {
        next[EDIT_RECEIVER_GENDER_NAME] =
          EDIT_RECEIVER_PERSONAL_DETAILS_GENDER_FIELD.msgRequired;
        return next;
      }

      if (mobileConfig?.eitherRequired) {
        if (!currentReceiverMobile && !currentReceiverPhone) {
          setEitherRequiredMsg('form_mobile_phone_invalid_1');
        } else {
          setEitherRequiredMsg('');
        }
        return next;
      }

      if (mobileConfig?.visible && mobileConfig?.required && !mobileNumber) {
        next[EDIT_RECEIVER_MOBILE_NAME] =
          EDIT_RECEIVER_GENERAL_DETAILS_PHONE_NUMBER_FIELDS[0].msgRequired;
      }

      if (phoneConfig?.visible && phoneConfig?.required && !phoneNumber) {
        next[EDIT_RECEIVER_PHONE_NAME] =
          EDIT_RECEIVER_GENERAL_DETAILS_PHONE_NUMBER_FIELDS[1].msgRequired;
      }

      if (
        relationshipConfig?.visible &&
        relationshipConfig?.required &&
        !currentReceiverRelationship
      ) {
        next[EDIT_RECEIVER_RELATIONSHIP_NAME] =
          EDIT_RECEIVER_RELATIONSHIP_FIELD.msgRequired;
      }

      return next;
    };
    useEffect(() => {
      const nextValidation = computeValidation();
      console.log(
        `⭐ UpdateReceiverPersonalDetailsValidationInitialComponent 👉 useEffect ➡️ 1 ➡️ nextValidation ↩`,
        nextValidation,
      );
      setValidation((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(nextValidation)) {
          return prev;
        }
        return nextValidation;
      });
    }, [
      currentReceiver,
      mobileConfig,
      phoneConfig,
      relationshipConfig,
      mobileNumber,
      phoneNumber,
      currentReceiverType,
      currentReceiverGender,
      currentReceiverMobile,
      currentReceiverPhone,
      currentReceiverRelationship,
    ]);

    const newProps = {
      ...props,
    };
    return <Component {...newProps} />;
  };
  return UpdateReceiverPersonalDetailsValidationInitialComponent;
};

export default withUpdateReceiverPersonalDetailsValidationInitial;
